class CustomTabs extends HTMLElement {
  constructor() {
      super();

      const tabBtns = this.querySelectorAll('.affiliate__tab-title');
      const tabBtnContent = this.querySelectorAll('.affiliate__tab-content');

      tabBtns.forEach((tabButton) => {
          tabButton.addEventListener('click', () => {
              tabBtns.forEach(btn => btn.classList.remove('affiliate__tab-title--active'));
              tabBtnContent.forEach(content => content.classList.remove('affiliate__tab-content--active'));

              tabButton.classList.add('affiliate__tab-title--active');
              const targetTab = tabButton.dataset.tabIndex;
              console.log(targetTab);

              document.querySelector(`.affiliate__tab-content[data-tab-index="${targetTab}"]`).classList.add('affiliate__tab-content--active');
          })
      })

  }
}

customElements.define('custom-tabs', CustomTabs);
